module.exports = __webpack_public_path__ + "img/toggle-on.97f5bf59.svg";